var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('app-header',{ref:"header",class:{ scrolled: _vm.scrolled },attrs:{"highlight":_vm.currentSection}}),_vm._v(" "),_c('app-cover',{ref:"cover"}),_vm._v(" "),_c('app-about',{ref:"about"}),_vm._v(" "),_c('app-portfolio',{ref:"works"}),_vm._v(" "),_c('app-contact',{ref:"contact"}),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b69bab9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = null
// module chunks = 